import {primary, secondary} from "./colors";

export const newUITheme = {
    overrides: {
        MuiButton: {
            root: {}
        }
    },
    typography: {
        useNextVariants: true,
    },
    palette: {
        primary: {
            main: primary
        },
        secondary: {
            main: secondary
        }
    },
};
